import WaybillsTableColumnStatus from './index.vue'
export default WaybillsTableColumnStatus